import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { patientActions } from '_actions';
import styles from './RTM.module.css';
import { CheckBox, EditNoteButton, StatusGood } from '_components';
import { PatientHomeAdmissionRTMNote } from './RTMNote';


class PatientHomeAdmissionRTM extends React.Component {



    startRTMNote() {
        this.props.toggleVisibility({ epno: this.props.epno });
    }

    adminOverride() {
        this.props.enableRtm(this.props.epno);
    }

    render() {
        return (
            <div>
                <div className={styles.rtm_header}>
                    <span>Remote Therapeutic Monitoring</span>
                </div>

                <div className={styles.enabled_wrapper}>
                    <span className={styles.indicator}>
                        <CheckBox title={this.props.rtmEnabled ? 'RTM is enabled for this patient' : 'RTM is NOT enabled for this patient'} label='Enabled' checked={this.props.rtmEnabled} disabled={true} />
                    </span>
                    <span className={styles.start_note}>
                        {this.props.allowNewNote &&
                            <EditNoteButton title='Create RTM Note' size='extra-small' onClick={() => this.startRTMNote()} />
                        }
                        {this.props.adminOverrideVisible && !this.props.rtmEnabled &&
                            <StatusGood title='Admin Enable Override' size='extra-small' onClick={() => this.adminOverride()} />
                        }
                    </span>
                </div>

                {this.props.rtmVisible &&
                    <PatientHomeAdmissionRTMNote epno={this.props.epno} />
                }


            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        enableRtm: bindActionCreators(patientActions.enableRtmForAdmission, dispatch),
        toggleVisibility: bindActionCreators(patientActions.toggleRtmVisibility, dispatch),

    };
}


function mapStateToProps(state, ownprops) {
    let ptno = state.entities.admissions[ownprops.epno].ptno;
    let discipline = state.entities.admissions[ownprops.epno].discipline;
    let rtmEnabled = state.entities.admissions[ownprops.epno].isRTMEnabled;
    let rtmActive = state.entities.admissions[ownprops.epno].isRTMActive;
    let allowNewNote = rtmEnabled && rtmActive && state.entities.authentication.user.islicensed ? true : false;
    let adminOverrideVisible = state.entities.authentication.user.isRtmAdmin;
    let rtmVisible = state.ui.admissions[ownprops.epno].rtmVisible;

    let similarRtmAdmissions = Object.keys(state.entities.admissions)
        .filter(key => {
            return state.entities.admissions[key].ptno === ptno &&
                state.entities.admissions[key].discipline === discipline &&
                state.entities.admissions[key].isRTMEnabled;
        })
        .sort((a, b) => new Date(state.entities.admissions[b].startDate).getTime() - new Date(state.entities.admissions[a].startDate).getTime())
        .map(key => state.entities.admissions[key]);

    return {
        rtmEnabled,
        rtmActive,
        allowNewNote,
        adminOverrideVisible,
        similarRtmAdmissions,
        rtmVisible,
    };
}

const connectedPatientHomeAdmissionRTM = connect(mapStateToProps, mapDispatchToProps)(PatientHomeAdmissionRTM);
export { connectedPatientHomeAdmissionRTM as PatientHomeAdmissionRTM };

